/**
 * From a problem+json `code` to a sentence somebody reading the log can act on.
 *
 * Short, because this screen has one verb. `cursor_invalid` earns its own line: a stale cursor
 * is a list that moved on, not a failure, and telling somebody to reload is the whole fix.
 */

import { ApiError } from '@/api/client';
import type { MessageKeys } from '@/lib/i18n';

type Key = MessageKeys['activity'];

/** Codes from `ErrorCode` in `backend/src/kalqa/core/errors.py`. TWIN: that enum. */
const BY_CODE: Readonly<Record<string, Key>> = {
  forbidden: 'error.forbidden',
  not_found: 'error.gone',
  rate_limited: 'error.rateLimited',
  cursor_invalid: 'error.cursor',
};

export function activityErrorKey(error: unknown): Key {
  if (!(error instanceof ApiError)) return 'error.unexpected';
  return BY_CODE[error.code] ?? 'error.unexpected';
}
